var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignupProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_420_1395)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_420_1395",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 110,
    height: 110
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_420_1395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0352 43.8984H59.1877V52.5425V57.1188V61.6951H50.0352C50.6515 54.7425 50.6199 50.8506 50.0352 43.8984Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7773 43.8984H55.6248V52.5425V57.1188V61.6951H64.7773C64.161 54.7425 64.1926 50.8506 64.7773 43.8984Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9054 58.9803C43.9959 57.2056 46.1922 56.3134 49.2712 55.3381C52.9811 54.163 63.7541 54.825 65.034 55.3381C66.2431 55.8229 70.0502 56.4391 74.2147 59.6075C74.6871 59.9669 75.2927 60.1184 75.8818 60.0456C88.9912 58.4251 93.3597 75.8063 99.356 79.4907C105.492 83.261 106.946 87.1921 109.526 94.4126L94.2713 94.4126C90.9336 92.2952 88.8976 90.594 87.2727 88.7233C85.9702 87.2239 83.31 87.9282 83.2411 89.9132L83.0848 94.4126H32.7458L32.4331 88.8902C32.3922 88.1671 32.2787 87.4478 32.0602 86.7574C31.1422 83.8559 30.0363 81.881 28.4937 79.8789C26.5816 77.3973 23.4206 76.3412 20.2883 76.3966C13.6876 76.5132 8.94316 75.2335 1.86305 71.0227C1.86305 71.0227 -15.5154 65.1881 -11.3573 59.3278C-7.19925 53.4676 -5.80921 50.4603 1.47459 46.4617C8.45838 39.5263 12.7876 36.0963 21.5898 32.8155C21.7373 32.7605 21.882 32.7142 22.0346 32.6757C23.7149 32.2512 34.4715 29.6681 36.8136 32.4788C38.846 34.9179 39.4375 37.1016 38.9265 40.0316C38.6708 41.4981 37.4031 42.5341 35.9309 42.7544C36.1369 44.2473 35.8595 44.4633 35.1304 44.717C34.0538 45.0918 32.7163 45.8504 31.7999 45.1724C31.4525 44.9155 30.9464 44.3535 29.9492 43.1568C27.4068 40.1059 24.5571 39.8517 24.2358 39.5975C23.9145 39.3432 18 45.4449 17.7647 45.8532C17.5688 46.193 11.8365 55.6645 10.6142 57.6502C12.0414 55.9192 19.4235 56.0773 23.301 59.0006C23.9142 59.4629 24.7041 59.6902 25.4368 59.4604C31.5362 57.5479 34.7541 56.5466 39.166 59.2079C40.0278 59.7278 41.1381 59.6317 41.9054 58.9803Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2259 33.499C46.9775 33.247 47.8396 33.1138 48.5342 33.3271C50.151 33.8236 48.5342 43.7508 48.5342 43.7508C47.2711 43.9094 46.0764 43.4622 44.9749 42.4797C43.6419 41.2906 43.8545 38.6027 44.1541 36.6966C44.3655 35.3515 44.935 33.9319 46.2259 33.499Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3288 33.499C68.5772 33.247 67.7151 33.1138 67.0205 33.3271C65.4037 33.8236 67.0205 43.7508 67.0205 43.7508C68.2836 43.9094 69.4783 43.4622 70.5798 42.4797C71.9128 41.2906 71.7001 38.6027 71.4006 36.6966C71.1892 35.3515 70.6197 33.9319 69.3288 33.499Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1044 33.9831C70.5001 44.0711 65.4394 50.75 57.4094 48.2204C50.0773 50.2842 45.3711 43.7827 46.0894 34.2373C45.0909 26.3583 50.4048 19.9802 57.7843 20C65.4785 19.9918 70.5828 26.1132 69.1044 33.9831Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4451 57.8815C49.5518 52.3642 49.6384 49.2923 47.6484 43.8984H51.9705V57.8815H50.4451Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1917 57.8815C66.0849 52.3642 65.9983 49.2923 67.9883 43.8984H63.6662V57.8815H65.1917Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1264 110C33.4303 103.897 32.8486 102.034 32.7422 94.2373H83.0812C83.2255 100.947 82.4273 103.88 81.6688 110H34.1264Z",
    fill: "#D9D9D9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_420_1395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupProfile);
export default __webpack_public_path__ + "static/media/signup-profile.f87eb20358bb10e2003f1d61a27fee7c.svg";
export { ForwardRef as ReactComponent };